import type { PayloadAction } from '@reduxjs/toolkit';

import { SET_BROWSER_LANGUAGE, type BrowserLanguage } from './types';

const initialState: BrowserLanguage | null = null;

export function browserLanguageReducer(
	state = initialState,
	action: PayloadAction<BrowserLanguage | null>,
): BrowserLanguage | null {
	switch (action.type) {
		case SET_BROWSER_LANGUAGE:
			return action.payload;
		default:
			return state;
	}
}
